export const userDashboard = "/dashboard/dashboard";
export const nonParentCategories = "/category/get-non-parent-categories";
